export default __webpack_public_path__ + "static/media/cartest.f9bb5dbd.svg";